// Returns a zone's UTC offset (minutes) at the given instant, via Intl -
// used to match zone aliases (e.g. "Asia/Calcutta" vs "Asia/Kolkata" both
// resolve to the same wall-clock offset even though the IANA name differs).
const offsetMinutesFor = (zone, date) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: zone,
    timeZoneName: "shortOffset",
  }).formatToParts(date);
  const offsetPart = parts.find((p) => p.type === "timeZoneName")?.value ?? "";
  const match = offsetPart.match(/GMT([+-])(\d{1,2})(?::?(\d{2}))?/);
  if (!match) return null;
  const sign = match[1] === "-" ? -1 : 1;
  const hours = Number(match[2]);
  const minutes = Number(match[3] ?? 0);
  return sign * (hours * 60 + minutes);
};

// Resolves the browser's IANA timezone (e.g. "Asia/Kolkata") and matches it
// against the app's supported timezone list. Falls back to the first entry
// (UTC) if detection fails or the browser's zone doesn't match any supported
// option (by name, then by current UTC offset to handle IANA aliases like
// Asia/Calcutta === Asia/Kolkata).
export const detectBrowserTimezone = (timezones) => {
  try {
    const browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const nameMatch = timezones.find((tz) => tz.value === browserZone);
    if (nameMatch) return nameMatch;

    const now = new Date();
    const browserOffset = offsetMinutesFor(browserZone, now);
    if (browserOffset === null) return timezones[0];

    const offsetMatch = timezones.find(
      (tz) => offsetMinutesFor(tz.value, now) === browserOffset
    );
    return offsetMatch || timezones[0];
  } catch (error) {
    return timezones[0];
  }
};
